<!--故障台账列表-->
<template>
    <div class="faultList">
        <van-nav-bar
            title="故障台账"
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <van-pull-refresh
            class="warpper"
            v-model="refreshLoading"
            @refresh="onRefresh"
            v-if="dataList.length>0"
        >
            <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                @load="onLoad"
                finished-text="没有更多了"
            >
                <div
                    :class="['materialPlan-item', item.accidenttype===3?'status01':'']"
                    v-for="(item,index) in dataList"
                    :key="index"
                >
                    <div :class="['corner-marker', item.status===1?'feedback-wcl':'feedback-other']">
                        <p class="text">
                            {{ status[item.status] }}
                        </p>
                    </div>
                    <ul>
                        <li class="tit">
                            <span class="pre-icon iconfont icontixing"></span>
                            <span class="info">
                                {{ accentTypes[item.accidenttype] }}
                                <template v-if="item.accidenttype===3">
                                    -{{ traffictypes[item.traffictype] }}
                                </template>
                            </span>
                        </li>
                        <li class="name-length">
                            <span class="pre-icon material01"></span>
                            <span class="info">工程位置：{{ item.accident }}</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="11">
                                    <span class="pre-icon material02"></span>
                                    <span class="info">车牌号:{{ item.licensenumber }}</span>
                                </van-col>
                                <van-col span="13">
                                    <span class="pre-icon material03"></span>
                                    <span class="info">车号:{{ item.carnumber }}</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="11">
                                    <span class="pre-icon material04"></span>
                                    <span class="info">驾驶员:{{ item.driver }}</span>
                                </van-col>
                                <van-col span="13">
                                    <span class="pre-icon material05"></span>
                                    <span class="info">联系电话:{{ item.phone }}</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon material06"></span>
                            <span class="info">报备时间:{{ item.reportedtime }}</span>
                        </li>
                    </ul>
                    <div class="btn-wrapper">
                        <span class="btn" @click="feedResult(item)">
                            反馈结果
                        </span>
                        <template v-if="item.status!=2&&item.status!=3">
                            <div class="line"></div>
                            <span class="btn" @click="addFault(item.Id)">
                                编辑
                            </span>
                        </template>
                        <template v-else>
                            <div class="line"></div>
                            <span class="btn" @click="handleView(item)">
                                查看
                            </span>
                        </template>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
        <div class="no_data" v-else></div>
        <div class="add-feed" @click="addFault('')">
            <span class="iconfont icontixing"></span>
            <span>报备</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'fault-list',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'fault-list');
        }
        next();
    },
    data() {
        return {
            refreshLoading: false,
            loading: false,
            finished: false,

            error: false,
            pageindex: 1,
            pagesize: 10,

            dataList: [],
            status: {
                0: '新上报',
                1: '未处理',
                2: '已处理',
                3: '已办结',
            },
            accentTypes: {
                1: '车辆故障',
                2: '车辆超载',
                3: '交通事故',
                4: '其他',
            },
            traffictypes: {
                1: '我方责任',
                2: '对方责任',
                3: '双方责任',
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        onLoad() {
            setTimeout(() => {
                this.pageindex += 1;
                this.loading = true;
                this.getList();
            }, 200);
        },
        onRefresh() {
            this.pageindex = 0;
            this.finished = false;
            this.refreshLoading = true;
            this.dataList = [];
            this.getList();
        },
        getList() {
            this.$axios
                .get('/interfaceApi/logistics/car_feedback/get_carfeedbacks?pageindex='
                    + this.pageindex + '&pagesize='
                    + this.pagesize)
                .then(res => {
                    const rows = res.rows || [];
                    this.dataList.push(...rows);
                    if (this.dataList.length >= res.total) {
                        this.finished = true;
                    }
                    if (this.refreshLoading) {
                        this.refreshLoading = false;
                    }
                    this.loading = false;

                }) .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.errorText = error.ErrorCode.Message;
                });
        },
        // 去反馈
        addFault(id) {
            this.$router.isBack = 2;
            this.$store.commit('noKeepAlive', 'fault-list');
            this.$router.push({
                path: '/faultForm',
                query: {
                    Id: id || '',
                },
            });
        },
        // 反馈结果
        feedResult(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'feedbackResult',
                path: '/feedbackResult',
                params: {
                    canEdit: true,
                    data: item,
                },
            });
        },

        // 查看
        handleView(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/faultDetail',
                query: {
                    Id: item.Id,
                },
            });
        },
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.back();
        },
    },
};
</script>

<style lang="stylus" scoped>
.faultList
    height calc(100% - 44rpx)
    position relative
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    // .no_data
    //     width 100%;
    //     height calc(100% - 45rpx)
    //     background url(./../../../assets/images/common/no_data.png) left center no-repeat
    //     background-size 100% 100%
    .warpper
        height calc(100% - 45rpx)
        background #F0F0F0
        overflow-y auto
        overflow-x hidden
        padding 0 12rpx 12rpx 12rpx
        .materialPlan-item
            &.status01
                .icontixing
                    color #D6010F
            width 100%
            background #ffffff
            margin-top 15rpx
            position relative
            overflow hidden
            padding 12rpx
            color #666666
            font-size 14rpx
            li
                overflow hidden
                margin-bottom 10rpx
                white-space nowrap
                &.name-length
                    display flex
                    .info
                        flex 1
                .icontixing
                    color #979EA7
                .pre-icon
                    width 16rpx
                    height 16rpx
                    float left
                    background-size 100% 100%
                    background-repeat no-repeat
                    display inline-block
                    margin 2rpx 10rpx 0 0
                    &.material01
                        background-image url(./../../../assets/images/icons/icon_gy_2.png)
                    &.material02
                        background-image url(./../../../assets/images/icons/icon_gy_9.png)
                    &.material03
                        background-image url(./../../../assets/images/icons/icon_18.png)
                    &.material04
                        background-image url(./../../../assets/images/icons/icon_3.png)
                    &.material05
                        background-image url(./../../../assets/images/icons/icon_4.png)
                    &.material06
                        background-image url(./../../../assets/images/icons/icon_gy_7.png)
                .info
                    float left
                .info-bar
                    float left
                    width 125rpx
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden
                &.tit
                    font-size 18rpx
                    color #061F3E
            .feedback-wcl
                background #D6010F
            .feedback-other
                background #979EA7
            .corner-marker
                width 60rpx
                height 60rpx
                position absolute
                right -30rpx
                top -30rpx
                transform rotate(45deg)
                -webkit-transform rotate(45deg)
                -moz-transform rotate(45deg)
                font-size 10rpx
                text-align center
                .text
                    position absolute
                    bottom 0.1rem;
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .btn-wrapper
                border-top 2rpx solid #F0F0F0
                padding-top 15rpx
                display flex
                justify-content space-around
                align-items center
                .line
                    width: 1px;
                    height: 15rpx
                    background: #D7D7D7;
                .btn
                    width 80rpx;
                    height 30rpx
                    text-align center
                    border-radius 4rpx
                    display flex
                    justify-content center
                    align-items center
                    background #fff;
                    border 1px solid #5494F3
                    color #5494F3

    .add-feed
        position fixed
        right 10rpx;
        bottom 10rpx;
        width: 40rpx;
        height: 50rpx;
        background: #0189FC;
        box-shadow: 2rpx 2rpx 4rpx 0px rgba(0, 0, 0, 0.35);
        border-radius: 4rpx;
        display flex
        justify-content center
        align-items center
        flex-direction column
        span
            font-size 12rpx;
            color #fff;
        .icontixing
            margin-bottom 3rpx;
            font-size 18rpx;
</style>
